import { Box, Button, Grid, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"
import { LoadingButton } from "@mui/lab"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { CustomTable } from "../../../../../../../../components"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { AddUserProps } from "./types"
import { MessageUsersAdded, MessageUsersExisted } from "../../../../../../../questionnaire/pages/permission/components/messages"
import { useStyles } from "./styles"


const AddUsers = ({ cleanFilter, rigthItem, searchButton, row, close, usersAlreadyAdded, handleAddUsers }: AddUserProps) => {


    const { t } = useTranslation()
    const styles = useStyles()
    const [selects, setSelects] = useState<(number | string)[]>([])
    const [error, setError] = useState(false)
    const [usersAdded, setUsersAdded] = useState(0)
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { }
    })
    const columnsPermissions = [
        {
            id: 'name',
            label: t('general.tags.name'),
        },
        {
            id: 'area',
            label: t('general.tags.area'),
        },
        {
            id: 'userType',
            label: t('general.tags.userType'),
        },
        {
            id: 'role',
            label: t('general.tags.role'),
        },
    ]

    const handleSelects = (value: number[]) => {
        setSelects(value)
    }

    const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

    const searchUsers = () => {
        if (!!selects.length) {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t("general.userFilterWarningTitle"),
                description: t("general.userFilterWarningDescription"),
                cancel: closeModal,
                confirm: () => {
                    searchButton.onClick()
                    setSelects([])
                    closeModal()
                }
            }))
        } else {
            searchButton.onClick()
        }
    }

    const closeModalPermissions = () => {
        setSelects([])
        close()
        setError(false)
        setUsersAdded(0)
    }

    const handleUserToAdd = () => {
        const newUsers = selects.filter(id => !usersAlreadyAdded.includes(id as number));
        if (newUsers.length > 0) {
            setUsersAdded(newUsers.length);
            const usersToAdd = row.filter(item => newUsers.includes(item.id)).map(item => ({
                id: item.id,
                name: item.name,
                area: item.area,
                department: item.department,
                userType: item.userType,
                role: item.role,
                applies: false,
                delete: false,
            }))
            handleAddUsers({ usersToAdd })
            return;
        } else {
            setError(true)
            setUsersAdded(0);
            return;
        }
    }

    const messageComponent = useMemo(() => {
        if (!usersAdded && !error) return undefined
        if (error) return <MessageUsersExisted return={() => { closeModalPermissions() }} />
        return <MessageUsersAdded usersAmmount={usersAdded} return={closeModalPermissions} />
    }, [usersAdded, error])

    return (
        <Grid container sx={{ height: '100%' }} spacing={3}>

            <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
                <CustomPaper elevation={2} sx={{ height: '100%' }}>
                    <Typography sx={[styles.createTitle,]} fontWeight={'bold'}>{t('Questionarie.permissions.searchForUsers')}</Typography>

                    <Box sx={styles.contentRight}>
                        <Box sx={styles.content}>
                            {rigthItem}
                        </Box>

                        <Box sx={styles.footerBtn}>
                            <Button onClick={cleanFilter} variant="text">{t('general.cleanFilters')}</Button>

                            <LoadingButton loading={!!searchButton.loading} disabled={searchButton.disabled} onClick={() => { searchUsers() }} variant='contained'>{t("general.searchUsers")}</LoadingButton>
                        </Box>
                    </Box>

                    <SimpleModal
                        open={modal.open}
                        close={() => { closeModal() }}
                        removeClose={!modal?.cancel}
                        title={modal.title}
                        description={modal.description}
                        buttonText={t('general.confirm')}
                        cancelText={t('general.cancel')}
                        back={modal?.cancel ?? undefined}
                        next={modal.confirm ?? closeModal}
                    />
                </CustomPaper>
            </Grid>

            <Grid item xl={8} lg={8} md={12} sm={12} xs={12} >
                <CustomPaper elevation={2} sx={{ height: '100%' }}>
                    <Box sx={styles.permissionTable}>
                        <Box sx={[styles.goBack, styles.alignItems]}>
                            <Typography fontWeight={'bold'}>{t('userGroup.titles.sellectUsersToAddPermission')}</Typography>

                            <Box sx={styles.containerButton}>
                                <Typography sx={styles.userSelected({ haveUser: Boolean(selects?.length) })}><span>{selects?.length ?? 0}</span> usuarios seleccionados</Typography>
                                <Button variant="contained" disabled={!selects?.length} onClick={handleUserToAdd}>{t("general.continue")}</Button>
                            </Box>
                        </Box>

                        {
                            <Box sx={{
                                '& .table-container.table-container': {
                                    maxHeight: '581px'
                                }
                            }}>
                                {
                                    messageComponent ?
                                        messageComponent
                                        :
                                        (
                                            <CustomTable
                                                tableChecks
                                                defaulPagination={20}
                                                defaultChecks={selects}
                                                onClick={(e) => { handleSelects(e.checks ?? []) }}
                                                name="Informe General"
                                                dontRefresh
                                                column={columnsPermissions}
                                                row={row ?? []}
                                                selected={-1}
                                                loader={searchButton.loading}
                                            />
                                        )
                                }

                            </Box>
                        }
                    </Box>
                </CustomPaper>
            </Grid>
        </Grid>
    )
}

export { AddUsers }